// Attribute display helper:
// normalize attribute names and keep "common" values distinguishable in tags.

const COMMON_VALUE = '\u5171\u901a';

const normalizeAttrName = (s: string): string => {
  return String(s ?? '')
    .trim()
    .replace(/[\uFF1A:]\s*$/, '')
    .replace(/\s+/g, '')
    .toLowerCase();
};

const COMMON_PREFIX_ATTR_NAMES_NORM = new Set<string>(
  [
    '\u30d7\u30ed\u30b8\u30a7\u30af\u30c8',
    'Project',
    'project',
    '\u30d1\u30ef\u30fc\u30c8\u30ec\u30a4\u30f3',
    'powertrain',
    'Powertrain',
    '\u4ed5\u5411\u3051',
    '\u30ed\u30c3\u30c8',
    'lot',
  ].map(normalizeAttrName)
);

export const formatAttrValueForDisplay = (p: { attr_name: string; attr_value: string }): string => {
  const rawName = String(p.attr_name ?? '').trim().replace(/[\uFF1A:]\s*$/, '');
  const value = String(p.attr_value ?? '').trim();

  if (value === COMMON_VALUE && COMMON_PREFIX_ATTR_NAMES_NORM.has(normalizeAttrName(rawName))) {
    return `${rawName}／${value}`;
  }
  return value;
};
